import { useTranslation } from 'react-i18next';
import { getDate, getMonth, getYear } from 'date-fns';
import { SpecialDay } from '../../types';
import { FullCalendar } from './FullCalendar';
import { MonthCalendar } from './MonthCalendar';
import { ListCalendar } from './ListCalendar';
import { NavigationButtons } from './NavigationButtons';
import { observer } from 'mobx-react';
import { Layout, SegmentedItem } from '@iba-team/portal-react-components/dist';
import { ArrowButtons } from '../../utils_components/ArrowButtons';
import { currentDate, TableDataType } from '../../store/Calendar';

interface CalendarContentI{
  activeTable: string,
  setActiveTable: (value: string) => void,
  tableData: TableDataType,
  setDataSource: (data: SpecialDay[])=> void,
  dataSource: ReadonlyArray<SpecialDay>,
  setTableData: (value: TableDataType) => void,
}

export const CalendarContent = observer((props:CalendarContentI) => {
  const { activeTable, setActiveTable, tableData, setTableData, dataSource} = props;
  const { t } = useTranslation();

  const handleClick = (operation: 'prev' | 'next') => {
    if(activeTable === 'Month'){
      setTableData({ date: operation === 'next' ?
        new Date(getYear(tableData.date), getMonth(tableData.date)+1, getDate(tableData.date))
        :
        new Date(getYear(tableData.date), getMonth(tableData.date)-1, getDate(tableData.date)) });
    }
    else{
      setTableData({date: operation === 'next'?
        new Date(getYear(tableData.date)+1, getMonth(tableData.date), getDate(tableData.date))
        :
        new Date(getYear(tableData.date)-1, getMonth(tableData.date), getDate(tableData.date))});
    }
  };

  return (
    <Layout className={'tablePage'}>
      {activeTable !== 'Month' &&
      <div className={'table_header'}>
        <div className={'table_header_left'}>
          <SegmentedItem onClick={() => setTableData({ date: currentDate })} theme={{variant: 'neutral', color: 'grey'}}>
            {t('currentDate')}
          </SegmentedItem>
          <ArrowButtons onLeftClick={() => handleClick('prev')} onRightClick={() => handleClick('next')}/>
          <div className={'current_year'}>
            <div>{getYear(tableData.date)}</div>
          </div>
        </div>
        <NavigationButtons setDataSource={props.setDataSource} dataSource={props.dataSource} activeTable={activeTable} setActiveTable={setActiveTable}/>
      </div>
      }
      {activeTable === 'Year' &&
        <FullCalendar setDataSource={props.setDataSource} date={tableData.date} dataSource={props.dataSource} />
      }
      {activeTable === 'Month' &&
          <MonthCalendar setDataSource={props.setDataSource} tableData={tableData} activeTable={activeTable} setActiveTable={setActiveTable}
            setTableData={setTableData}
            dataSource={dataSource} />
      }
      {activeTable === 'List' &&
          <ListCalendar setDataSource={props.setDataSource} dataSource={dataSource} />
      }
    </Layout>
  );
});
